
import { useState, useEffect } from 'react';

export default function MobileFloatingNav() {
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [isNearBottom, setIsNearBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      setShowScrollButtons(scrollY > 300);
      setIsNearBottom(scrollY + windowHeight >= documentHeight - 200);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* Botão flutuante de Email - Mobile */}
      <a
        href="mailto:contact@braxfacility.com"
        className="md:hidden fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-r from-[#3B82F6] to-[#60A5FA] rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-all duration-300 active:scale-95"
        aria-label="Send Email"
      >
        <i className="ri-mail-send-line text-white text-xl"></i>
      </a>

      {/* Botão flutuante de Email - Desktop */}
      <a
        href="mailto:contact@braxfacility.com"
        className="hidden md:flex fixed bottom-8 right-8 z-50 items-center gap-3 bg-gradient-to-r from-[#3B82F6] to-[#60A5FA] px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group cursor-pointer"
        aria-label="Send Email"
      >
        <i className="ri-mail-send-line text-white text-xl"></i>
        <span className="text-white font-medium text-sm">Email Us</span>
      </a>

      {/* Botões de navegação vertical - Mobile Only */}
      <div 
        className={`md:hidden fixed left-4 bottom-6 z-50 flex flex-col gap-2 transition-all duration-300 ${
          showScrollButtons ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        {/* Ir ao topo */}
        <button
          onClick={scrollToTop}
          className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center border border-gray-200 hover:bg-white transition-all active:scale-95"
          aria-label="Scroll to top"
        >
          <i className="ri-arrow-up-line text-[#0F172A] text-lg"></i>
        </button>

        {/* Ir ao formulário/final */}
        {!isNearBottom && (
          <button
            onClick={scrollToBottom}
            className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center border border-gray-200 hover:bg-white transition-all active:scale-95"
            aria-label="Scroll to contact"
          >
            <i className="ri-arrow-down-line text-[#0F172A] text-lg"></i>
          </button>
        )}
      </div>
    </>
  );
}
